export enum PremiumPackageType {
  consumerPro = 'expause_consumer_pro',
  creatorPro = 'expause_creator_pro',
  identityPro = 'expause_identity_pro',
}
